var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.7 35",
    enableBackground: "new 0 0 47.7 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M0 1h47.7M0 10h47.7M0 18h47.7M0 26h47.7M0 34h47.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoller);
export default __webpack_public_path__ + "static/media/roller.f3f5c2fb9dda7d6ea01b101b19a670ac.svg";
export { ForwardRef as ReactComponent };